import "./Persona.scss";

const Colors = [
  "#0078D4",
  "#7DB9E8",
  "#008272",
  "#00B294",
  "#C4314B",
  "#ED5E62",
  "#FFB900",
  "#F8D22A",
  "#122945",
  "#37435E",
  "#84869A",
  "#87C7A0",
  "#BEDEC7",
  "#EC666B",
  "#3D3E78",
  "#444791",
  "#5B5FC7",
  "#9299F7",
  "#616161",
  "#858585"
];

function hashColor(str) {
  const strSum = str.split("").reduce((sum, curr) => {
    return sum + curr.charCodeAt(0);
  }, 0);

  return Colors[strSum % Colors.length];
}

function Persona({ firstName, lastName, className = "" }) {
  const color = hashColor(`${firstName}${lastName}`);
  const initials = `${firstName && firstName[0]}${lastName && lastName[0]}`;

  return (
    <>
      <div style={{ background: color }} className={`persona ${className}`}>
        {initials}
      </div>
    </>
  );
}

export default Persona;
